import React from "react";
import "../styles/VideoRecomendacion.css";

function VideoRecomendacion() {
  return (
    <section className="video-section bg-light my-5">
      <div className="container">
        <div className="video-heading">
          <h2>Nuestros alumnos nos recomiendan</h2>
          <p>
            Transforma tu vida y alcanza tus metas con nosotros. Descubre como
            podemos ayudarte a lograrlo.
          </p>
        </div>

        <div className="video-container">
          <iframe
            className="video-content"
            src="https://www.youtube.com/embed/FMZ7EratnJc"
            title="Testimonio de alumno de Fundacion Nican"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default VideoRecomendacion;
